import React, { useState, useEffect } from "react";
import { css } from "linaria";
import { MenuLink, MenuItem } from "@reach/menu-button";
import "@reach/menu-button/styles.css";

import UpcomingFlyers from "../../UpcomingFlyers";
import AppLink from "../../AppLink";

import { useAuthState, useAuthDispatch } from "../../../contexts/Auth/context";
import { logOut } from "../../../contexts/Auth/actions";

import MouseOverMenuButton from "../../MenuButton/MouseOverMenuButton";

const ReachMenuListOverride = css`
  @apply bg-white w-72 border-dove;

  &[data-reach-menu-list] {
    @apply text-sm border-dove;
    padding: 0;
  }

  & [data-reach-menu-item] {
    @apply text-sm;
    padding: 0.5rem 0.75rem;
  }

  & [data-reach-menu-item][data-selected] {
    @apply text-black bg-dove;
  }
`;

const AccountActions = ({}) => {
  const [childClicked, setChildClicked] = useState(false);
  const { accountInfo: { id, display_name, email_address } } = useAuthState();
  const dispatch = useAuthDispatch(); // get the dispatch method from the useDispatch custom hook

  useEffect(() => {
    setTimeout(() => setChildClicked(false), 100);
  }, [childClicked]);

  const menuButtonContent = (
    <>
      <span className="paragraph-small text-black hover:text-black">
        {display_name || email_address}
      </span>
    </>
  );
  const menuListClass = ReachMenuListOverride;
  const menuListContent = (
    <>
      <UpcomingFlyers useMenuItems={true} />
      <MenuLink
        className="paragraph-small"
        href="/buy_coins"
        as={AppLink}
        tracking={{ id: "Buy Coins" }}
        onSelect={() => setChildClicked(true)}
      >
        Buy Coins
      </MenuLink>
      <MenuLink
        className="paragraph-small"
        href="/manage"
        as={AppLink}
        tracking={{ id: "My Events" }}
        onSelect={() => setChildClicked(true)}
      >
        My Events
      </MenuLink>
      <MenuLink
        className="paragraph-small"
        href="/manage/draft"
        as={AppLink}
        tracking={{ id: "Drafts" }}
        onSelect={() => setChildClicked(true)}
      >
        Drafts
      </MenuLink>
      <MenuLink
        className="paragraph-small"
        href="/accounts/address_book"
        as={AppLink}
        tracking={{ id: "Address Book" }}
        onSelect={() => setChildClicked(true)}
      >
        Address Book
      </MenuLink>
      <MenuLink
        className="paragraph-small"
        href={`/accounts/${id}/edit`}
        as={AppLink}
        tracking={{ id: "Account Settings" }}
        onSelect={() => setChildClicked(true)}
      >
        Account Settings
      </MenuLink>
      <MenuLink
        className="paragraph-small"
        href="/help"
        as={AppLink}
        tracking={{ id: "Help Center" }}
        onSelect={() => setChildClicked(true)}
      >
        Help Center
      </MenuLink>
      <MenuItem
        className="paragraph-small"
        onSelect={() => {
          logOut(dispatch);
          setChildClicked(true);
        }}
      >
        Log out
      </MenuItem>
    </>
  );

  // If these are MenuLinks that use 'as={AppLink}' then we lose their magic highlighting and selections mangament.  Need to know how valuable these are.
  return (
    <MouseOverMenuButton
      menuButtonContent={menuButtonContent}
      menuListClass={menuListClass}
      menuListContent={menuListContent}
      childClicked={childClicked}
    />
  );
};

export default React.memo(AccountActions);
